import styled from 'styled-components';

export const NodeSidebarContainer = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  min-height: calc(100vh - 61px);
  max-height: calc(100vh - 61px);
  background-color: ${({ theme }) => theme.background.standard};
  border-left: 1px solid ${({ theme }) => theme.line.light};
  min-width: 390px;

  ::-webkit-scrollbar {
    width: 14px;
    height: 14px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.scrollbar.track};
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.scrollbar.thumb};
  }
`;

export const NodeSidebarCodebox = styled.div`
  display: flex;
  border: 1px solid ${({ theme }) => theme.line.light};
  border-radius: 8px;

  white-space: nowrap;
  overflow-x: auto;
  overflow-y: auto;

  max-height: calc(100vh - 170px - 20px - 8rem);

  code {
    border-radius: 8px;
  }

  ::-webkit-scrollbar {
    width: 14px;
    height: 14px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.scrollbar.track};
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.scrollbar.thumb};
  }
`;
